"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<nav class="nav">
  <div class="container">
    <a class="brand" href="#top">
      <img src="/assets/images/logo-inthub.png" alt="${'landing.img.logo'.t()}">
    </a>
    <div class="d-inline-block">
            <lang-switcher></lang-switcher>
    </div>
    <ul class="nav-links">
      <li><a href="#wprowadzenie">${'landing.nav.about'.t()}</a></li>
      <li><a href="#moduly">${'landing.nav.modules'.t()}</a></li>
      <li><a href="#asystenci">${'landing.nav.assistants'.t()}</a></li>
      <li><a href="#content-studio">${'landing.nav.contentStudio'.t()}</a></li>
      <li><a href="#analityka">${'landing.nav.analytics'.t()}</a></li>
      
    </ul>
    <div class="nav-cta">
      <a class="btn btn-solid btn-sm" href="/login">${'landing.nav.login'.t()}</a>
      <button class="nav-toggle" id="navToggle" aria-label="Otwórz menu" aria-expanded="false">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
      </button>
    </div>
  </div>
  <div class="nav-mobile-panel" id="navMobilePanel">
    <ul>
      <li><a href="#wprowadzenie">${'landing.nav.about'.t()}</a></li>
      <li><a href="#moduly">${'landing.nav.modules'.t()}</a></li>
      <li><a href="#asystenci">${'landing.nav.assistants'.t()}</a></li>
      <li><a href="#content-studio">${'landing.nav.contentStudio'.t()}</a></li>
      <li><a href="#analityka">${'landing.nav.analytics'.t()}</a></li>
      
    </ul>
  </div>
</nav>

<main id="top">

  
  <section class="hero on-light">
    <span class="hero-bg-accent" aria-hidden="true"></span>
    <div class="hero-photo" aria-hidden="true"></div>
    <div class="container">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="eyebrow">${'landing.hero.eyebrow'.t()}</span>
          <h1>${'landing.hero.title1'.t()}<br>${'landing.hero.title2'.t()}<br><em>${'landing.hero.title3'.t()}</em></h1>
          <p class="lede">${'landing.hero.lede'.t()}</p>
          <div class="hero-actions">
            <a class="btn btn-solid" href="/login">${'landing.hero.ctaLogin'.t()}</a>
            <a class="btn btn-ghost-light" href="#moduly">${'landing.hero.ctaModules'.t()}</a>
          </div>
          <p class="hero-note">${'landing.hero.note'.t()}</p>
        </div>

        <div class="hero-visual">
          <div class="device">
            <div class="device-bar"><span></span><span></span><span></span></div>
            <div class="device-body">
              <div class="device-title">${'landing.hero.deviceTitle'.t()}</div>
              <div class="device-sub">${'landing.hero.deviceSub'.t()}</div>
              <div class="chip-row">
                <span class="model-chip"><span class="dot dot-success"></span>${'landing.model.openai'.t()}</span>
                <span class="model-chip"><span class="dot dot-accent"></span>${'landing.model.claudeSonnet'.t()}</span>
                <span class="model-chip"><span class="dot dot-info"></span>${'landing.model.deepseek'.t()}</span>
                <span class="model-chip"><span class="dot dot-circuit"></span>${'landing.model.gemini'.t()}</span>
                <span class="model-chip"><span class="dot dot-violet"></span>${'landing.model.claudeHaiku'.t()}</span>
              </div>
              <div class="device-input">
                <span>${'landing.hero.deviceInput'.t()}</span>
                <span class="send">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12h16M14 6l6 6-6 6"/></svg>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
  <section class="section-light on-light" id="wprowadzenie">
    <div class="container">
      <div class="intro-grid">
        <div class="reveal">
          <span class="eyebrow">${'landing.intro.eyebrow'.t()}</span>
          <h2 style="font-size:clamp(1.9rem,2.4vw + 1rem,2.6rem);margin:.8rem 0 0;">${'landing.intro.title'.t()}</h2>
        </div>
        <div class="reveal">
          <p class="lede">${'landing.intro.lede1'.t()}</p>
          <p class="lede" style="margin-top:1rem;">${'landing.intro.lede2'.t()}</p>
        </div>
      </div>

      <div class="stat-row reveal">
        <div class="stat-cell"><div class="num">${'landing.stat.providers'.t()}</div><div class="lab">${'landing.stat.providersLab'.t()}</div></div>
        <div class="stat-cell"><div class="num">${'landing.stat.roles'.t()}</div><div class="lab">${'landing.stat.rolesLab'.t()}</div></div>
        <div class="stat-cell"><div class="num">${'landing.stat.multitenant'.t()}</div><div class="lab">${'landing.stat.multitenantLab'.t()}</div></div>
        <div class="stat-cell"><div class="num">${'landing.stat.credits'.t()}</div><div class="lab">${'landing.stat.creditsLab'.t()}</div></div>
      </div>
    </div>
  </section>

  
  <section class="section-soft on-light" id="moduly">
    <div class="container">
      <div class="section-head reveal">
        <span class="eyebrow">${'landing.modules.eyebrow'.t()}</span>
        <h2>${'landing.modules.title'.t()}</h2>
        <p class="lede">${'landing.modules.lede'.t()}</p>
      </div>

      <div class="module-grid">
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M4 5.5h16v10.5H8.5L4 20V5.5Z"/></svg></div>
          <h3>${'landing.module.chat.title'.t()}</h3>
          <p>${'landing.module.chat.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><circle cx="12" cy="8.2" r="3.4"/><path d="M5 20c1.2-3.9 4-5.7 7-5.7s5.8 1.8 7 5.7"/></svg></div>
          <h3>${'landing.module.assistants.title'.t()}</h3>
          <p>${'landing.module.assistants.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M4 5.6C4 4.7 4.7 4 5.6 4H12v16H5.6A1.6 1.6 0 0 1 4 18.4V5.6Z"/><path d="M20 5.6c0-.9-.7-1.6-1.6-1.6H12v16h6.4a1.6 1.6 0 0 0 1.6-1.6V5.6Z"/></svg></div>
          <h3>${'landing.module.knowledge.title'.t()}</h3>
          <p>${'landing.module.knowledge.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 9.5h17M8 3v4M16 3v4"/></svg></div>
          <h3>${'landing.module.contentStudio.title'.t()}</h3>
          <p>${'landing.module.contentStudio.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M3 12.6 12.6 3H20v7.4L10.4 20 3 12.6Z"/><circle cx="15.6" cy="7.4" r="1.3"/></svg></div>
          <h3>${'landing.module.styles.title'.t()}</h3>
          <p>${'landing.module.styles.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M4 21V13M10.5 21V7M17 21v-6"/><path d="M2 21h20"/></svg></div>
          <h3>${'landing.module.costs.title'.t()}</h3>
          <p>${'landing.module.costs.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><rect x="4" y="3" width="10" height="18" rx="1"/><rect x="14" y="10" width="6" height="11" rx="1"/><path d="M7 7h1M7 11h1M7 15h1"/></svg></div>
          <h3>${'landing.module.management.title'.t()}</h3>
          <p>${'landing.module.management.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M12 3l7 3v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V6l7-3Z"/><path d="M9 12l2 2 4-4"/></svg></div>
          <h3>${'landing.module.logs.title'.t()}</h3>
          <p>${'landing.module.logs.desc'.t()}</p>
        </div>
        <div class="module-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><rect x="3" y="6" width="18" height="13" rx="2"/><path d="M3 10h18"/><path d="M7 15h4"/></svg></div>
          <h3>${'landing.module.pricing.title'.t()}</h3>
          <p>${'landing.module.pricing.desc'.t()}</p>
        </div>
      </div>
    </div>
  </section>

  
  <section class="section-dark on-dark photo-bg" id="asystenci">
    <div class="container">
      <div class="showcase">
        <div class="showcase-copy reveal">
          <span class="eyebrow">${'landing.assistants.eyebrow'.t()}</span>
          <h2>${'landing.assistants.title'.t()}</h2>
          <p class="lede">${'landing.assistants.lede'.t()}</p>
          <ul class="feature-list">
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.assistants.feature1'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.assistants.feature2'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.assistants.feature3'.t()}</li>
          </ul>
        </div>
        <div class="showcase-visual reveal">
          <div class="visual-photo"><img src="/assets/images/bg1.jpg" alt="${'landing.img.bg1'.t()}" loading="lazy"></div>
          <div class="avatar-grid">
            <div class="avatar-card">
              <div class="avatar-top">
                <span class="avatar-avatar"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2"/><path d="M5 19.5c1.1-3.6 3.8-5.3 7-5.3s5.9 1.7 7 5.3"/></svg></span>
                <div><div class="avatar-name">${'landing.avatar.historian'.t()}</div><div class="avatar-role">${'landing.avatar.historianRole'.t()}</div></div>
              </div>
              <span class="status-pill">${'landing.avatar.statusConfig'.t()}</span>
            </div>
            <div class="avatar-card">
              <div class="avatar-top">
                <span class="avatar-avatar"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2"/><path d="M5 19.5c1.1-3.6 3.8-5.3 7-5.3s5.9 1.7 7 5.3"/></svg></span>
                <div><div class="avatar-name">${'landing.avatar.hive'.t()}</div><div class="avatar-role">${'landing.avatar.hiveRole'.t()}</div></div>
              </div>
              <span class="status-pill">${'landing.avatar.statusConfig'.t()}</span>
            </div>
            <div class="avatar-card">
              <div class="avatar-top">
                <span class="avatar-avatar"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2"/><path d="M5 19.5c1.1-3.6 3.8-5.3 7-5.3s5.9 1.7 7 5.3"/></svg></span>
                <div><div class="avatar-name">${'landing.avatar.communicator'.t()}</div><div class="avatar-role">${'landing.avatar.communicatorRole'.t()}</div></div>
              </div>
              <span class="status-pill">${'landing.avatar.statusConfig'.t()}</span>
            </div>
            <div class="avatar-card">
              <div class="avatar-top">
                <span class="avatar-avatar"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.2"/><path d="M5 19.5c1.1-3.6 3.8-5.3 7-5.3s5.9 1.7 7 5.3"/></svg></span>
                <div><div class="avatar-name">${'landing.avatar.whatsapp'.t()}</div><div class="avatar-role">${'landing.avatar.whatsappRole'.t()}</div></div>
              </div>
              <span class="status-pill">${'landing.avatar.statusConfig'.t()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
  <section class="section-light on-light" id="content-studio">
    <div class="container">
      <div class="showcase reverse">
        <div class="showcase-copy reveal">
          <span class="eyebrow">${'landing.cs.eyebrow'.t()}</span>
          <h2>${'landing.cs.title'.t()}</h2>
          <p class="lede">${'landing.cs.lede'.t()}</p>
          <ul class="feature-list">
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.cs.feature1'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.cs.feature2'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.cs.feature3'.t()}</li>
          </ul>
        </div>
        <div class="showcase-visual reveal">
          <div class="cs-card">
            <div class="cs-stats">
              <div><div class="n">0</div><div class="l">${'landing.cs.statScheduled'.t()}</div></div>
              <div><div class="n">0</div><div class="l">${'landing.cs.statApproval'.t()}</div></div>
              <div><div class="n">1</div><div class="l">${'landing.cs.statPublished'.t()}</div></div>
              <div><div class="n">1</div><div class="l">${'landing.cs.statTotal'.t()}</div></div>
            </div>
            <div class="cs-post">
              <div class="cs-post-top"><strong>${'landing.cs.postTitle'.t()}</strong><span class="status-pill" style="background:#e5f4ec;color:#238a5f;">${'landing.cs.postStatus'.t()}</span></div>
              <p>${'landing.cs.postContent'.t()}</p>
            </div>
            <div class="cs-suggest">
              <span>${'landing.cs.suggest1'.t()}</span>
              <span>${'landing.cs.suggest2'.t()}</span>
              <span>${'landing.cs.suggest3'.t()}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  
  <section class="section-dark on-dark photo-bg" id="analityka">
    <div class="container">
      <div class="showcase">
        <div class="showcase-copy reveal">
          <span class="eyebrow">${'landing.analytics.eyebrow'.t()}</span>
          <h2>${'landing.analytics.title'.t()}</h2>
          <p class="lede">${'landing.analytics.lede'.t()}</p>
          <ul class="feature-list">
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.analytics.feature1'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.analytics.feature2'.t()}</li>
            <li><svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12l5 5L20 6"/></svg>${'landing.analytics.feature3'.t()}</li>
          </ul>
        </div>
        <div class="showcase-visual reveal">
          <div class="an-card">
            <div class="an-metrics">
              <div><div class="n">page-landing.63833</div><div class="l">${'landing.analytics.totalCost'.t()}</div></div>
              <div><div class="n">920 180</div><div class="l">${'landing.analytics.tokens'.t()}</div></div>
              <div><div class="n">55</div><div class="l">${'landing.analytics.messages'.t()}</div></div>
              <div><div class="n">$0.02979</div><div class="l">${'landing.analytics.avgCost'.t()}</div></div>
              <div><div class="n">32</div><div class="l">${'landing.analytics.topMessages'.t()}</div></div>
              <div><div class="n">Web113</div><div class="l">${'landing.analytics.topAvatar'.t()}</div></div>
            </div>
            <svg class="an-chart" viewBox="0 0 420 140" preserveAspectRatio="none">
              <line x1="0" y1="20" x2="420" y2="20" stroke="#382b3f" stroke-width="1"/>
              <line x1="0" y1="60" x2="420" y2="60" stroke="#382b3f" stroke-width="1"/>
              <line x1="0" y1="100" x2="420" y2="100" stroke="#382b3f" stroke-width="1"/>
              <path d="M0,90 L60,70 L120,130 L180,58 L240,118 L300,112 L360,15 L420,132" fill="none" stroke="#e58cbe" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
              <circle cx="360" cy="15" r="4.5" fill="#e58cbe"/>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>

  
  <section class="section-light on-light">
    <div class="container">
      <div class="section-head reveal">
        <span class="eyebrow">${'landing.management.eyebrow'.t()}</span>
        <h2>${'landing.management.title'.t()}</h2>
        <p class="lede">${'landing.management.lede'.t()}</p>
      </div>
      <div class="split">
        <div class="split-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><rect x="4" y="3" width="10" height="18" rx="1"/><rect x="14" y="10" width="6" height="11" rx="1"/><path d="M7 7h1M7 11h1M7 15h1"/></svg></div>
          <h3>${'landing.management.companies.title'.t()}</h3>
          <p>${'landing.management.companies.desc'.t()}</p>
          <div class="mini-table">
            <div class="mini-row head"><span>${'landing.management.table.company'.t()}</span><span>${'landing.management.table.city'.t()}</span><span>${'landing.management.table.status'.t()}</span></div>
            <div class="mini-row"><span>${'landing.management.company1'.t()}</span><span>${'landing.management.warsaw'.t()}</span><span class="status-pill" style="background:#e5f4ec;color:#238a5f;">${'landing.management.active'.t()}</span></div>
            <div class="mini-row"><span>${'landing.management.company2'.t()}</span><span>${'landing.management.krakow'.t()}</span><span class="status-pill" style="background:#e5f4ec;color:#238a5f;">${'landing.management.active'.t()}</span></div>
            <div class="mini-row"><span>${'landing.management.company3'.t()}</span><span>${'landing.management.elk'.t()}</span><span class="status-pill" style="background:#e5f4ec;color:#238a5f;">${'landing.management.active'.t()}</span></div>
          </div>
        </div>
        <div class="split-card reveal">
          <div class="module-icon"><svg viewBox="0 0 24 24"><path d="M12 3l7 3v6c0 5-3.5 7.5-7 9-3.5-1.5-7-4-7-9V6l7-3Z"/><path d="M9 12l2 2 4-4"/></svg></div>
          <h3>${'landing.management.logs.title'.t()}</h3>
          <p>${'landing.management.logs.desc'.t()}</p>
          <div class="mini-table">
            <div class="mini-row head"><span>${'landing.management.table.model'.t()}</span><span>${'landing.management.table.operation'.t()}</span><span>${'landing.management.table.date'.t()}</span></div>
            <div class="mini-row"><span>${'landing.management.opConversation'.t()}</span><span class="badge-op badge-create">${'landing.management.opCreate'.t()}</span><span>11:52</span></div>
            <div class="mini-row"><span>${'landing.management.opMessage'.t()}</span><span class="badge-op badge-create">${'landing.management.opCreate'.t()}</span><span>11:52</span></div>
            <div class="mini-row"><span>${'landing.management.opCurrency'.t()}</span><span class="badge-op badge-update">${'landing.management.opUpdate'.t()}</span><span>11:50</span></div>
          </div>
        </div>
      </div>
    </div>
  </section>

  

  
  <section class="cta-final on-dark photo-bg">
    <div class="container">
      <span class="eyebrow" style="justify-content:center;">${'landing.cta.eyebrow'.t()}</span>
      <h2 style="margin-top:1rem;">${'landing.cta.title'.t()}</h2>
      <p class="lede">${'landing.cta.lede'.t()}</p>
      <div class="hero-actions">
        <a class="btn btn-solid" href="/login">${'landing.cta.button'.t()}</a>
      </div>
    </div>
  </section>

</main>

<footer>
  <div class="container">
    <a class="brand" href="#top"><img src="/assets/images/logo-inthub.png" alt="${'landing.img.logo'.t()}"></a>
    <ul class="foot-links">
      <li><a href="#moduly">${'landing.nav.modules'.t()}</a></li>
      
      <li><a href="/login">${'landing.footer.panel'.t()}</a></li>
    </ul>
    <span>${'landing.footer.copyright'.t()}</span>
  </div>
</footer>
`;
require("./styles/layout.scss");
const styles = T.css `*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

main {
  margin: auto !important;
}

body {
  margin: 0;
  overflow-x: hidden;
  background: #ffffff;
  color: #1e1a22;
  font-family: "IBM Plex Sans", -apple-system, "Segoe UI", sans-serif;
  font-size: 16px;
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
}

img {
  max-width: 100%;
  display: block;
}

a {
  color: inherit;
  text-decoration: none;
}

h1, h2, h3, h4 {
  font-family: "Fraunces", Georgia, "Times New Roman", serif;
  font-weight: 600;
  line-height: 1.12;
  text-wrap: balance;
  margin: 0;
}

p {
  margin: 0;
}

.container {
  max-width: 1180px;
  margin: 0 auto;
  padding: 0 28px;
}

section {
  position: relative;
}
section[id] {
  scroll-margin-top: 88px;
}

::selection {
  background: #a01e6b;
  color: #ffffff;
}

:focus-visible {
  outline: 2px solid #a01e6b;
  outline-offset: 3px;
}

.eyebrow {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.72rem;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 0.5em;
}
.eyebrow::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #a01e6b;
  flex: none;
}
.on-dark .eyebrow {
  color: #e58cbe;
}
.on-light .eyebrow {
  color: #a01e6b;
}

.lede {
  font-size: 1.08rem;
  max-width: 62ch;
}
.on-dark .lede {
  color: #b6a7bf;
}
.on-light .lede {
  color: #655c6e;
}

.nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 12px 30px -20px rgba(0, 0, 0, 0.65);
}
.nav::before {
  content: "";
  position: absolute;
  inset: -40px;
  z-index: 0;
  background: url("/assets/images/bg0.jpg") center/cover no-repeat;
  filter: blur(7px) brightness(0.5) saturate(1.15);
  transform: scale(1.08);
  height: 69px;
}
.nav::after {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: linear-gradient(180deg, rgba(18, 12, 22, 0.72), rgba(18, 12, 22, 0.9));
}
.nav .container {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 68px;
}
.nav-links {
  display: flex;
  align-items: center;
  gap: 2rem;
  list-style: none;
  margin: 0;
  padding: 0;
}
.nav-links a {
  font-size: 0.92rem;
  color: rgba(255, 255, 255, 0.82);
  font-weight: 500;
  transition: color 0.15s ease;
}
.nav-links a:hover {
  color: #fff;
}
.nav-cta {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}
.nav-toggle {
  display: none;
  background: none;
  border: 1px solid rgba(255, 255, 255, 0.28);
  border-radius: 8px;
  width: 40px;
  height: 40px;
  color: #fff;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.nav-mobile-panel {
  display: none;
}
.nav-mobile-panel.open {
  display: block;
  position: fixed;
  top: 68px;
  left: 0;
  right: 0;
  background: rgba(18, 12, 22, 0.96);
  backdrop-filter: blur(8px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 18px 28px;
  z-index: 99;
  box-shadow: 0 18px 34px -22px rgba(0, 0, 0, 0.7);
}
.nav-mobile-panel.open ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.nav-mobile-panel.open a {
  color: #fff;
  font-size: 0.98rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  font-family: "Fraunces", Georgia, "Times New Roman", serif;
  font-weight: 600;
  font-size: 1.2rem;
  color: #fff;
}
.brand img {
  height: 40px;
  width: auto;
  display: block;
  border-radius: 0;
}
.brand-mark {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #a01e6b;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-weight: 600;
  font-size: 0.95rem;
  flex: none;
}

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  font-family: "IBM Plex Sans", -apple-system, "Segoe UI", sans-serif;
  font-weight: 600;
  font-size: 0.94rem;
  padding: 0.8rem 1.5rem;
  border-radius: 9px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}
.btn-solid {
  background: linear-gradient(135deg, #b23079, #7c1450);
  color: #ffffff;
}
.btn-solid:hover {
  background: linear-gradient(135deg, #a3236c, #6a1044);
  transform: translateY(-1px);
  box-shadow: 0 10px 24px -10px rgba(160, 30, 107, 0.6);
}
.btn-ghost-dark {
  border-color: #382b3f;
  color: #f3eef5;
}
.btn-ghost-dark:hover {
  border-color: #b6a7bf;
}
.btn-ghost-light {
  border-color: #e7e0eb;
  color: #1e1a22;
}
.btn-ghost-light:hover {
  border-color: #a01e6b;
  color: #a01e6b;
}
.btn-sm {
  padding: 0.55rem 1.1rem;
  font-size: 0.85rem;
}

.hero {
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: #ffffff;
  color: #1e1a22;
  overflow: hidden;
  padding: 120px 0 80px;
}
.hero-bg-accent {
  position: absolute;
  left: -10%;
  top: -20%;
  width: 640px;
  height: 640px;
  border-radius: 50%;
  background: radial-gradient(circle at center, #f4e3ee, transparent 70%);
  pointer-events: none;
}
.hero-photo {
  position: absolute;
  top: 0;
  right: 0;
  width: 50%;
  height: 100%;
  background: url("/assets/images/bg2.webp") center/cover no-repeat;
}
.hero-photo::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, #ffffff 0%, rgba(255, 255, 255, 0.55) 14%, rgba(255, 255, 255, 0) 46%), linear-gradient(180deg, rgba(95, 44, 116, 0.1), rgba(20, 10, 25, 0.3));
}
.hero .container {
  position: relative;
  z-index: 2;
  width: 100%;
}
.hero-grid {
  display: grid;
  grid-template-columns: 1.02fr 0.98fr;
  gap: 48px;
  align-items: center;
}
.hero-grid > * {
  min-width: 0;
}
.hero .lede, .hero-note {
  overflow-wrap: anywhere;
}
.hero h1 {
  font-size: clamp(2.3rem, 3.6vw + 1rem, 3.6rem);
  margin: 1rem 0 1.3rem;
}
.hero h1 em {
  font-style: normal;
  color: #a01e6b;
}
.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-top: 2rem;
}
.hero-note {
  margin-top: 1.6rem;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.78rem;
  color: #655c6e;
  letter-spacing: 0.02em;
}
.hero-visual {
  display: flex;
  justify-content: center;
}
.hero .device {
  width: 100%;
  max-width: 440px;
  box-shadow: 0 40px 80px -30px rgba(20, 10, 25, 0.55);
}

.device {
  background: #1e1622;
  border: 1px solid #382b3f;
  border-radius: 16px;
  box-shadow: 0 30px 60px -25px rgba(0, 0, 0, 0.6);
  overflow: hidden;
}
.device-bar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 12px 16px;
  border-bottom: 1px solid #382b3f;
}
.device-bar span {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #382b3f;
}
.device-body {
  padding: 22px;
}
.device-title {
  font-family: "Fraunces", Georgia, "Times New Roman", serif;
  font-size: 1.15rem;
  color: #f3eef5;
  margin-bottom: 6px;
}
.device-sub {
  font-size: 0.85rem;
  color: #b6a7bf;
  margin-bottom: 18px;
}
.device-input {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: #161018;
  border: 1px solid #382b3f;
  border-radius: 10px;
  padding: 0.85rem 1rem;
  font-size: 0.86rem;
  color: #b6a7bf;
}
.device-input .send {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #a01e6b;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
}

.chip-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 18px;
}

.model-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.74rem;
  color: #f3eef5;
  background: #271d2c;
  border: 1px solid #382b3f;
  padding: 0.4rem 0.7rem;
  border-radius: 999px;
}

.dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex: none;
}
.dot-accent {
  background: #e58cbe;
}
.dot-circuit {
  background: #3e9e97;
}
.dot-info {
  background: #4d76a8;
}
.dot-success {
  background: #2f9e6e;
}
.dot-violet {
  background: #b79bd6;
}

.section-light {
  background: #ffffff;
  color: #1e1a22;
  padding: 104px 0;
}

.section-soft {
  background: #f7f4f8;
  color: #1e1a22;
  padding: 104px 0;
  border-top: 1px solid #e7e0eb;
  border-bottom: 1px solid #e7e0eb;
}

.section-dark {
  background: #161018;
  color: #f3eef5;
  padding: 104px 0;
}

.section-head {
  max-width: 680px;
  margin-bottom: 56px;
}
.section-head h2 {
  font-size: clamp(1.9rem, 2.4vw + 1rem, 2.7rem);
  margin: 0.8rem 0 1rem;
}
.on-dark .section-head h2 {
  color: #f3eef5;
}
.on-light .section-head h2 {
  color: #1e1a22;
}

.photo-bg {
  position: relative;
  background-color: #161018;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
.photo-bg::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(16, 10, 20, 0.9), rgba(16, 10, 20, 0.82));
}
.photo-bg > .container {
  position: relative;
  z-index: 1;
}

#asystenci.photo-bg {
  background-image: url("/assets/images/bg1.jpg");
}

#analityka.photo-bg {
  background-image: url("/assets/images/bg0.jpg");
}

.cta-final.photo-bg {
  background-image: url("/assets/images/bg-inthub.jpg");
}
.cta-final.photo-bg::before {
  background: linear-gradient(180deg, rgba(16, 10, 20, 0.86), rgba(16, 10, 20, 0.9));
}

.stat-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #e7e0eb;
  border: 1px solid #e7e0eb;
  border-radius: 14px;
  overflow: hidden;
  margin-top: 56px;
}

.stat-cell {
  background: #ffffff;
  padding: 26px 24px;
}
.stat-cell .num {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-weight: 600;
  font-size: 1.5rem;
  color: #a01e6b;
  font-variant-numeric: tabular-nums;
}
.stat-cell .lab {
  font-size: 0.85rem;
  color: #655c6e;
  margin-top: 0.35rem;
}

.intro-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 64px;
  align-items: start;
}
.intro-grid .lede {
  max-width: none;
}

.module-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
}

.module-card {
  background: #ffffff;
  border: 1px solid #e7e0eb;
  border-radius: 16px;
  padding: 30px;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
}
.module-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 32px -20px rgba(95, 44, 116, 0.25);
  border-color: #d9cbe3;
}
.module-card h3 {
  font-size: 1.15rem;
  margin-bottom: 0.6rem;
  color: #1e1a22;
}
.module-card p {
  font-size: 0.92rem;
  color: #655c6e;
  line-height: 1.55;
}

.module-icon {
  width: 44px;
  height: 44px;
  border-radius: 11px;
  background: #f4e3ee;
  border: 1px solid #ecd8e5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #a01e6b;
  margin-bottom: 20px;
}
.module-icon svg {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.showcase {
  display: grid;
  grid-template-columns: 0.92fr 1.08fr;
  gap: 64px;
  align-items: center;
}
.showcase.reverse .showcase-copy {
  order: 2;
}
.showcase.reverse .showcase-visual {
  order: 1;
}
.showcase-copy h2 {
  font-size: clamp(1.8rem, 2.2vw + 1rem, 2.4rem);
  margin: 0.8rem 0 1rem;
}

.feature-list {
  list-style: none;
  margin: 1.6rem 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}
.feature-list li {
  display: flex;
  gap: 0.7rem;
  font-size: 0.94rem;
  align-items: flex-start;
}
.on-dark .feature-list li {
  color: #b6a7bf;
}
.on-light .feature-list li {
  color: #655c6e;
}
.feature-list svg {
  width: 18px;
  height: 18px;
  flex: none;
  margin-top: 0.2rem;
  color: #e58cbe;
}
.on-light .feature-list svg {
  color: #a01e6b;
}

.visual-photo {
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 16px;
  border: 1px solid #382b3f;
  box-shadow: 0 24px 50px -30px rgba(0, 0, 0, 0.6);
}
.visual-photo img {
  width: 100%;
  height: 220px;
  object-fit: cover;
  display: block;
}

.avatar-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;
}
.avatar-card {
  background: #1e1622;
  border: 1px solid #382b3f;
  border-radius: 14px;
  padding: 18px;
}
.avatar-top {
  display: flex;
  align-items: center;
  gap: 0.7rem;
  margin-bottom: 0.9rem;
}
.avatar-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #271d2c;
  border: 1px solid #382b3f;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #b6a7bf;
  flex: none;
}
.avatar-avatar svg {
  width: 16px;
  height: 16px;
  stroke: currentColor;
  fill: none;
  stroke-width: 1.6;
}
.avatar-name {
  font-weight: 600;
  font-size: 0.92rem;
  color: #f3eef5;
}
.avatar-role {
  font-size: 0.72rem;
  color: #b6a7bf;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
}

.status-pill {
  display: inline-block;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.68rem;
  letter-spacing: 0.03em;
  padding: 0.28rem 0.6rem;
  border-radius: 6px;
  background: rgba(47, 158, 110, 0.15);
  color: #59c793;
}

.cs-card {
  background: #ffffff;
  border: 1px solid #e7e0eb;
  border-radius: 16px;
  padding: 26px;
  box-shadow: 0 20px 45px -30px rgba(95, 44, 116, 0.35);
}
.cs-stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1px;
  background: #e7e0eb;
  border: 1px solid #e7e0eb;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 20px;
}
.cs-stats div {
  background: #ffffff;
  padding: 14px 12px;
}
.cs-stats .n {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-weight: 600;
  font-size: 1.15rem;
  color: #1e1a22;
}
.cs-stats .l {
  font-size: 0.68rem;
  color: #655c6e;
  margin-top: 0.2rem;
}
.cs-post {
  border: 1px solid #e7e0eb;
  border-radius: 12px;
  padding: 16px 18px;
  margin-bottom: 18px;
}
.cs-post-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
}
.cs-post-top strong {
  font-size: 0.95rem;
}
.cs-post p {
  font-size: 0.84rem;
  color: #655c6e;
}
.cs-suggest {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.cs-suggest span {
  font-size: 0.76rem;
  border: 1px solid #e7e0eb;
  border-radius: 999px;
  padding: 0.4rem 0.75rem;
  color: #655c6e;
  background: #f7f4f8;
}

.an-card {
  background: #1e1622;
  border: 1px solid #382b3f;
  border-radius: 16px;
  padding: 26px;
}
.an-metrics {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  margin-bottom: 22px;
}
.an-metrics div {
  background: #271d2c;
  border: 1px solid #382b3f;
  border-radius: 10px;
  padding: 14px 14px;
}
.an-metrics .n {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-weight: 600;
  font-size: 1.05rem;
  color: #f3eef5;
  font-variant-numeric: tabular-nums;
}
.an-metrics .l {
  font-size: 0.68rem;
  color: #b6a7bf;
  margin-top: 0.25rem;
}
.an-chart {
  width: 100%;
  height: auto;
  display: block;
}

.split {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 32px;
}
.split-card {
  background: #ffffff;
  border: 1px solid #e7e0eb;
  border-radius: 16px;
  padding: 32px;
}
.split-card .module-icon {
  margin-bottom: 22px;
}
.split-card h3 {
  font-size: 1.3rem;
  margin-bottom: 0.7rem;
}
.split-card p {
  color: #655c6e;
  font-size: 0.94rem;
  margin-bottom: 1.3rem;
}

.mini-table {
  border: 1px solid #e7e0eb;
  border-radius: 10px;
  overflow: hidden;
  font-size: 0.8rem;
}

.mini-row {
  display: grid;
  grid-template-columns: 1.4fr 1fr 0.9fr;
  gap: 0.5rem;
  padding: 0.6rem 0.9rem;
  border-bottom: 1px solid #e7e0eb;
  align-items: center;
}
.mini-row:last-child {
  border-bottom: none;
}
.mini-row.head {
  background: #f7f4f8;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.66rem;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #655c6e;
}

.badge-op {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.68rem;
  padding: 0.15rem 0.5rem;
  border-radius: 5px;
}

.badge-create {
  background: #e5f4ec;
  color: #2f9e6e;
}

.badge-update {
  background: #f4e3ee;
  color: #a01e6b;
}

.price-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.price-card {
  border: 1px solid #e7e0eb;
  border-radius: 18px;
  padding: 30px 26px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
}
.price-card.featured {
  border-color: #a01e6b;
  box-shadow: 0 24px 45px -28px rgba(160, 30, 107, 0.5);
  position: relative;
}
.price-name {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.78rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: #655c6e;
  margin-bottom: 0.7rem;
}
.price-amount {
  font-family: "Fraunces", Georgia, "Times New Roman", serif;
  font-size: 2.1rem;
  font-weight: 600;
  color: #1e1a22;
}
.price-amount span {
  font-family: "IBM Plex Sans", -apple-system, "Segoe UI", sans-serif;
  font-size: 0.85rem;
  font-weight: 500;
  color: #655c6e;
}
.price-credits {
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.78rem;
  color: #a01e6b;
  margin: 0.4rem 0 1.4rem;
}
.price-limits {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1.4rem;
  padding-bottom: 1.4rem;
  border-bottom: 1px solid #e7e0eb;
}
.price-limits div {
  display: flex;
  justify-content: space-between;
  font-size: 0.82rem;
  color: #655c6e;
}
.price-limits b {
  color: #1e1a22;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-weight: 600;
}
.price-features {
  list-style: none;
  margin: 0 0 1.6rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
  flex: 1;
}
.price-features li {
  display: flex;
  gap: 0.55rem;
  font-size: 0.84rem;
  color: #655c6e;
  align-items: flex-start;
}
.price-features svg {
  width: 16px;
  height: 16px;
  flex: none;
  margin-top: 0.15rem;
  color: #a01e6b;
}

.featured-tag {
  position: absolute;
  top: -13px;
  left: 26px;
  background: #a01e6b;
  color: #ffffff;
  font-family: "IBM Plex Mono", ui-monospace, "SFMono-Regular", Menlo, monospace;
  font-size: 0.66rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
}

.cta-final {
  background: #161018;
  color: #f3eef5;
  padding: 110px 0;
  text-align: center;
}
.cta-final h2 {
  font-size: clamp(2rem, 3vw + 1rem, 3rem);
  color: #f3eef5;
  max-width: 20ch;
  margin: 0 auto 1.1rem;
}
.cta-final .lede {
  margin: 0 auto;
  text-align: center;
}
.cta-final .hero-actions {
  justify-content: center;
  margin-top: 2.2rem;
}

footer {
  background: #161018;
  border-top: 1px solid #382b3f;
  color: #b6a7bf;
  padding: 36px 0;
}
footer .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  font-size: 0.82rem;
}
footer a {
  color: #b6a7bf;
}
footer a:hover {
  color: #f3eef5;
}
footer .brand {
  color: #f3eef5;
}
footer .brand img {
  height: 26px;
  width: auto;
  display: block;
  border-radius: 0;
}

.foot-links {
  display: flex;
  gap: 1.4rem;
  list-style: none;
  margin: 0;
  padding: 0;
}

.reveal {
  opacity: 0;
  transform: translateY(16px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}
.reveal.is-visible {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  html {
    scroll-behavior: auto;
  }
  .reveal {
    transition: none;
    opacity: 1;
    transform: none;
  }
  .btn,
  .module-card {
    transition: none;
  }
}
@media (max-width: 980px) {
  .hero {
    padding: 112px 0 64px;
    min-height: auto;
  }
  .hero-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .hero-photo {
    width: 100%;
  }
  .hero-photo::after {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.92));
  }
  .hero .device {
    max-width: none;
  }
  .intro-grid {
    grid-template-columns: 1fr;
    gap: 36px;
  }
  .stat-row {
    grid-template-columns: repeat(2, 1fr);
  }
  .module-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .showcase,
  .showcase.reverse {
    grid-template-columns: 1fr;
  }
  .showcase .showcase-copy,
  .showcase.reverse .showcase-copy {
    order: 1 !important;
  }
  .showcase .showcase-visual,
  .showcase.reverse .showcase-visual {
    order: 2 !important;
  }
  .split {
    grid-template-columns: 1fr;
  }
  .price-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .an-metrics {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 640px) {
  .nav-links {
    display: none;
  }
  .nav-toggle {
    display: flex;
  }
  .nav-mobile-panel.open {
    display: block;
    position: fixed;
    top: 68px;
    left: 0;
    right: 0;
    background: rgba(18, 12, 22, 0.96);
    backdrop-filter: blur(8px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    padding: 18px 28px;
    z-index: 99;
    box-shadow: 0 18px 34px -22px rgba(0, 0, 0, 0.7);
  }
  .nav-mobile-panel.open ul {
    list-style: none;
    margin: 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }
  .nav-mobile-panel.open a {
    color: #fff;
    font-size: 0.98rem;
  }
  .module-grid {
    grid-template-columns: 1fr;
  }
  .price-grid {
    grid-template-columns: 1fr;
  }
  .avatar-grid {
    grid-template-columns: 1fr;
  }
  .cs-stats,
  .an-metrics {
    grid-template-columns: repeat(2, 1fr);
  }
  .stat-row {
    grid-template-columns: 1fr 1fr;
  }
  footer .container {
    flex-direction: column;
    align-items: flex-start;
  }
}`;
const shadowOptions = { "mode": "open" };
let LandingPage = class LandingPage extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.navOpen = false;
        this.navToggle = null;
        this.navMobilePanel = null;
        this.revealObserver = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        // Nav toggle wiring
        this.navToggle = this.$('#navToggle');
        this.navMobilePanel = this.$('#navMobilePanel');
        if (this.navToggle) {
            this.navToggle.addEventListener('click', () => this.toggleNav());
        }
        // Smooth scroll for all nav anchor links (in shadow DOM)
        setTimeout(() => {
            const root = this.shadowRoot;
            if (!root) {
                console.warn('[LandingPage] no shadowRoot for nav scroll wiring');
                return;
            }
            const navLinks = root.querySelectorAll('a[href^="#"]');
            navLinks.forEach(link => {
                link.addEventListener('click', (e) => {
                    const href = link.getAttribute('href');
                    if (href && href.startsWith('#')) {
                        e.preventDefault();
                        const id = href.substring(1);
                        const el = root.getElementById(id);
                        if (el) {
                            el.scrollIntoView({ behavior: 'smooth' });
                        }
                        this.navOpen = false;
                        if (this.navMobilePanel) {
                            this.navMobilePanel.classList.remove('open');
                        }
                    }
                });
            });
        }, 300);
        // Defer reveal observer until template is fully stamped into shadow DOM
        setTimeout(() => this.setupRevealObserver(), 200);
    }
    setupRevealObserver() {
        const root = this.shadowRoot;
        if (!root) {
            console.warn('[LandingPage] no shadowRoot yet, retrying...');
            setTimeout(() => this.setupRevealObserver(), 100);
            return;
        }
        const revealElements = root.querySelectorAll('.reveal');
        console.log('[LandingPage] found reveal elements in shadow DOM:', revealElements.length);
        if (revealElements.length === 0) {
            console.warn('[LandingPage] no .reveal elements found in shadow DOM');
            return;
        }
        this.observeRevealElements(revealElements);
    }
    observeRevealElements(elements) {
        this.revealObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    console.log('[LandingPage] reveal element is visible:', entry.target);
                    entry.target.classList.add('is-visible');
                    this.revealObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.15 });
        elements.forEach((el, idx) => {
            console.log('[LandingPage] observing reveal element', idx, el);
            this.revealObserver.observe(el);
        });
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        if (this.revealObserver) {
            this.revealObserver.disconnect();
        }
    }
    toggleNav() {
        this.navOpen = !this.navOpen;
        if (this.navMobilePanel) {
            this.navMobilePanel.classList.toggle('open', this.navOpen);
        }
        if (this.navToggle) {
            this.navToggle.setAttribute('aria-expanded', String(this.navOpen));
        }
    }
    goToLogin(event) {
        this.navOpen = false;
        if (this.navMobilePanel) {
            this.navMobilePanel.classList.remove('open');
        }
        return true; // let the anchor's default target="_blank" navigation proceed
    }
    scrollToSection(id) {
        var _a;
        const el = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.getElementById(id);
        if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
        }
        this.navOpen = false;
        if (this.navMobilePanel) {
            this.navMobilePanel.classList.remove('open');
        }
    }
};
exports.LandingPage = LandingPage;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], LandingPage.prototype, "navOpen", void 0);
exports.LandingPage = LandingPage = __decorate([
    (0, client_1.RWSView)('page-landing', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], LandingPage);
LandingPage.defineComponent();
